import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Collapse, Form, Row, Col, Tabs, Tab, Modal, CloseButton, Spinner } from 'react-bootstrap';
import { courseFilters } from 'data/elearning/courseData';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import useRoutes from 'hooks/useRoutes';
import Treeview from 'components/common/Treeview';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';

const MutateRouter = ({ setPaths, err }) => {
 const [key, setKey] = useState('code');
 const [charg, setCharg] = useState(false);
 const {
  data,
  routes,
  permits,
  handleFilterOptions,
  filterOptions,
  parentsIds,
  setParentsIds,
  setFilterOptions,
  selectedItems,
  setSelectedItems,
  categories,
  setInputValue,
  disabled,
  inputValue,
  selectValue,
  setSelectValue,
  manageCategory,
  setAssignment,
  assignment,
  show,
  setShow,
  isLoading
 } = useRoutes();

 const onChange = ({ target: { value } }) => {
  setSelectValue(value);
  setAssignment(categories.find(e => e._id == value));
 };

 useEffect(() => {
  if (assignment?.routes) {
   setPaths(assignment);
   setSelectValue(categories.find(e => e.category === assignment?.category)?._id ?? assignment.value);
  }
 }, [assignment, categories]);

 useEffect(() => {
  setCharg(true);
 }, []);

 return (
  <>
   <Flex className="fs--2 mt-2 mt-sm-0" alignItems="center" wrap="nowrap">
    <div>
     <Input
      type="select"
      name="routes"
      placeholder="Seleccione rutas"
      errors={err ? { routes: true } : {}}
      options={[
       ...categories.map((option, i) => ({ key: i, label: option.category, value: option._id })),
       assignment?.category ? { key: assignment?.category, label: assignment?.category, value: 0 } : []
      ]}
      formControlProps={{
       size: 'sm',
       className: 'pe-7',
       value: selectValue,
       onChange,
       disabled: !categories.length && !assignment?.category
       //  readOnly: !categories.length && !assignment?.category
      }}
     />
    </div>
    {!disabled && (
     <IconButton
      icon={selectValue < 1 ? 'plus' : 'pencil-alt'}
      className="m-0 fs--1 mx-2"
      classText="d-none d-sm-block"
      transform="shrink-2"
      size="sm"
      variant={'falcon-default'}
      onClick={() => setShow(true)}
     >
      {selectValue < 1 ? 'Crear ruta' : 'Editar ruta'}
     </IconButton>
    )}
   </Flex>

   <Modal size="lg" show={show} onHide={setShow} className="mt-4 pb-4 pb-md-2">
    <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
     <div className="position-relative z-index-1 light">
      <h4 className="mb-0 text-white" id="authentication-modal-label">
       Rutas y Permisos
      </h4>
      <p className="fs--1 mb-0 text-white">Establece las rutas y permisos para un usuario</p>
     </div>
     <CloseButton variant="white" className="position-absolute end-0 me-2 mt-2 top-0" onClick={() => setShow(false)} />
    </Modal.Header>
    <Modal.Body as={Row} className="p-4 py-0 align-items-center justify-content-between">
     <Input
      type="text"
      name="name"
      label="Nombre de categoria"
      placeholder="Nombre de categoria..."
      help={{ title: 'NOMBRE DE RUTA', body: 'Establece un nombre de categoria para una ruta y asignarla a x tipo de usuarios' }}
      formGroupProps={{ as: Row, className: 'align-items-center g-3 mb-3' }}
      formLabelProps={{ className: 'text-lg-end', column: true, xs: 5 }}
      formColumnProps={{ xs: { span: 7, offset: 0 } }}
      formControlProps={{
       onChange: ({ target: { value } }) => setInputValue(value.toUpperCase()),
       value: inputValue,
       disabled: disabled,
       className: 'text-center',
       autoComplete: 'off',
       maxLength: 50,
       size: 'sm'
      }}
     />

     {filterOptions.length > 0 && (
      <Flex wrap="wrap" className="gap-2 mb-3">
       {filterOptions.map((tag, i) => (
        <SoftBadge key={i} className="bg-300 text-700 py-0">
         {tag}
         <Button
          size="sm"
          variant="link"
          className="p-0 text-700"
          onClick={() => setFilterOptions(filterOptions.filter(val => val !== tag))}
         >
          <FontAwesomeIcon icon="times" className="ms-1 fs--2" />
         </Button>
        </SoftBadge>
       ))}
      </Flex>
     )}
     <Col sm={5} className="mb-3 pt-4">
      <SimpleBarReact style={{ height: 340 }}>
       {charg && (
        <Treeview
         data={data}
         selection
         defaultSelected={[0]}
         selectedItems={selectedItems}
         setSelectedItems={setSelectedItems}
         expanded={['MKDTgOWFz3Kl-V-pVHApF', '5eqeoAXQqV7CbgtxwnZju', 'ocPHNGuej_aodg1TccLo6']}
         disabled={disabled}
        />
       )}
      </SimpleBarReact>
     </Col>
     <Col sm={7} className="mb-3">
      <Tabs id="controlled-tab-example" activeKey={key} onSelect={k => setKey(k)}>
       <Tab eventKey="permissions" title="Permisos" className="border-bottom border-x p-3">
        <SimpleBarReact style={{ height: 300 }}>
         {/* <pre className="fs--2">
                    <code>{JSON.stringify(permits, null, 2)}</code>
                  </pre>{' '} */}
         <ul className="list-unstyled px-1">
          {permits.map((filter, index) => (
           <FilterItem
            key={index}
            index={index}
            filter={filter}
            filterOptions={filterOptions}
            //setFilterOptions={setFilterOptions}
            handleFilterOptions={handleFilterOptions}
            disabled={disabled}
           />
          ))}
         </ul>
        </SimpleBarReact>
       </Tab>
       <Tab eventKey="code" title="Rutas" className="border-bottom border-x p-3">
        <SimpleBarReact style={{ height: 300 }}>
         {routes.length && <Treeview data={routes} expanded={parentsIds} setOpenedItems={setParentsIds} />}
        </SimpleBarReact>
       </Tab>
      </Tabs>
     </Col>
    </Modal.Body>
    <Modal.Footer>
     {isLoading && (
      <div className="p-0 flex-fill">
       <Spinner animation="grow" role="status" className="me-2 ms-n1">
        .........cargando...
       </Spinner>
      </div>
     )}
     <IconButton
      icon="ban"
      className="me-2"
      transform="shrink-2"
      classText="d-none d-sm-inline-block"
      size="sm"
      type="reset"
      variant={'falcon-default'}
      onClick={() => setShow(false)}
     >
      Cancelar
     </IconButton>

     <IconButton
      size="sm"
      className="me-2"
      variant="falcon-success"
      icon="user-plus"
      transform="shrink-3"
      disabled={disabled}
      onClick={() => {
       manageCategory('assign');
      }}
     >
      Asignar rutas
     </IconButton>

     <IconButton
      size="sm"
      className="me-2"
      variant="falcon-primary"
      icon={selectValue == 0 ? 'plus' : 'sync-alt'}
      transform="shrink-3"
      disabled={disabled}
      onClick={() => manageCategory()}
     >
      {selectValue == 0 ? 'Crear categoria y asignar' : 'Actualizar categoria y asignar'}
     </IconButton>
    </Modal.Footer>
   </Modal>
  </>
 );
};

const FilterItem = ({ filter, index, filterOptions, handleFilterOptions, disabled }) => {
 const [open, setOpen] = useState(false);
 return (
  <li className={`${courseFilters.length - 1 !== index && 'border-bottom'}`}>
   <Button
    variant="link"
    onClick={() => setOpen(!open)}
    aria-controls={`${filter.id}-collapse`}
    aria-expanded={index === 0 || index === 1 ? !open : open}
    className="collapse-indicator-plus w-100 fs--1 fw-medium text-start text-600 text-decoration-none py-2 px-0"
   >
    {filter.icon && <FontAwesomeIcon icon={filter.icon} className="me-2 fs--1" />}
    {filter.name}
   </Button>

   <Collapse in={index === 0 || index === 1 ? !open : open} id={`${filter.id}-collapse`}>
    <ul className="list-unstyled">
     {filter?.permits.map((option, i) => (
      <li key={i}>
       <Form.Check type="checkbox" className="form-check d-flex ps-0">
        <Form.Check.Label className="fs--1 flex-1 text-truncate" htmlFor={`filter-${option.allow}`}>
         <div className="flex-1 mb-1 cursor-pointer ms-2">
          <h5 className="mb-0 fs--1 text-primary position-relative pb-2">
           {option.name}
           {/* <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span> */}
           <span className="position-absolute fs--2 top-50 start-0 mt-1 text-muted">{option.description}</span>
          </h5>
         </div>
        </Form.Check.Label>

        <Form.Check.Input
         type="checkbox"
         onChange={e => handleFilterOptions(e, filter)}
         checked={filterOptions.includes(option.allow)}
         id={`filter-${option.allow}`}
         name={option.name}
         value={option.allow}
         disabled={disabled}
        />
       </Form.Check>
      </li>
     ))}
    </ul>
   </Collapse>
  </li>
 );
};

FilterItem.propTypes = {
 index: PropTypes.number,
 filter: PropTypes.shape({
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  permits: PropTypes.array,
  options: PropTypes.arrayOf(
   PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
   })
  )
 }),
 handleFilterOptions: PropTypes.func,
 filterOptions: PropTypes.array,
 disabled: PropTypes.bool
};

MutateRouter.propTypes = { setPaths: PropTypes.func, err: PropTypes.bool };

MutateRouter.defaultProps = { err: false };

export default MutateRouter;
